import { handleActions } from 'redux-actions'
import { decodeJwt } from './utils'

import { authenticateDestroy, authenticateFailure, authenticateInitial, authenticateSuccess, resetPasswordSuccess } from './actions'

export const initialState = {
    isFetching: false,
    isAuthenticated: false,
    isImpersonated: false,
    errorMessage: null,
    isSendingSuccessReset: false,
}

export default handleActions(
    {
        [authenticateInitial]: (state, { payload }) => {
            return {
                ...state,
                isAuthenticated: !!(payload.accessToken && payload.refreshToken),
                isImpersonated: payload.isImpersonated || false,
            }
        },
        [authenticateSuccess]: (state, { payload }) => ({
            ...state,
            isFetching: false,
            isAuthenticated: true,
            isImpersonated: decodeJwt(payload.data.token).impersonation?.active || false,
            errorMessage: null,
        }),
        [authenticateFailure]: (state, { payload }) => ({
            ...initialState,
            isFetching: false,
            isAuthenticated: false,
            errorMessage: payload,
        }),
        [authenticateDestroy]: () => initialState,
        [resetPasswordSuccess]: (state) => ({
            ...state,
            isSendingSuccessReset: true,
        }),
    },
    initialState
)
